













import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator'
import {
  OperationTab,
  getOperationTabLabel,
} from '@/helpers/enums/OperationTab'


@Component
export default class OperationsTabs extends Vue {
  @Prop({
    type: String,
    default: OperationTab.planned,
    validator: (prop) => prop in OperationTab,
  })
  public current!: OperationTab;

  public get labels() {
    return [
      OperationTab.planned,
      OperationTab.completed,
    ].map((value) => ({
      value,
      label: getOperationTabLabel(value),
      active: this.current === value,
    }))
  }
}
